import axios from 'axios';
import { STORAGE } from '../constants/Storage';
import { logout } from '../store/authSlice';
import {
  AuthApi,
  Configuration,
  GoogleApi,
  ScheduleSettingsApi,
  UsersApi,
  RecruitmentTypeApi,
  DepartmentApi,
  PositionApi,
  GeneralConfigApi,
  BookingsApi,
  LocationsApi,
  ReportApi,
  ApprovalConfigApi,
  LeaveRegulationConfigApi,
  TimekeepingApi,
  ConfirmationsApi,
  OvertimeApi,
  ReminderTimeApi,
  ContactApi,
  SchedulesApi,
} from './client-axios';
import { toast } from 'react-toastify';

const config = new Configuration({
  basePath: process.env.REACT_APP_API_URL,
  accessToken: localStorage.getItem(STORAGE.TOKEN) || undefined,
});

export const axiosInstance = axios.create({
  timeout: 20000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      logout();
    } else if (error?.code === 'ECONNABORTED') {
      toast.error('リクエストのタイムアウトが発生しました。もう一度お試しください');
    }

    return Promise.reject(error);
  },
);

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE.TOKEN);

    if (!config?.headers?.Authorization && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const authApi = new AuthApi(config, undefined, axiosInstance);
const googleApi = new GoogleApi(config, undefined, axiosInstance);
const generalConfigApi = new GeneralConfigApi(config, undefined, axiosInstance);
const scheduleSettingApi = new ScheduleSettingsApi(config, undefined, axiosInstance);
const userApi = new UsersApi(config, undefined, axiosInstance);
const recruitmentTypeApi = new RecruitmentTypeApi(config, undefined, axiosInstance);
const departmentApi = new DepartmentApi(config, undefined, axiosInstance);
const positionApi = new PositionApi(config, undefined, axiosInstance);
const bookingApi = new BookingsApi(config, undefined, axiosInstance);
const locationApi = new LocationsApi(config, undefined, axiosInstance);
const reportApi = new ReportApi(config, undefined, axiosInstance);
const approvalConfigApi = new ApprovalConfigApi(config, undefined, axiosInstance);
const leaveRegulationConfigApi = new LeaveRegulationConfigApi(config, undefined, axiosInstance);
const timeKeepingApi = new TimekeepingApi(config, undefined, axiosInstance);
const regulationConfigApi = new LeaveRegulationConfigApi(config, undefined, axiosInstance);
const confirmationApi = new ConfirmationsApi(config, undefined, axiosInstance);
const overtimeSatisticApi = new OvertimeApi(config, undefined, axiosInstance);
const reminderTimeApi = new ReminderTimeApi(config, undefined, axiosInstance);
const contactApi = new ContactApi(config, undefined, axiosInstance);
const schedulesApi = new SchedulesApi(config, undefined, axiosInstance);

export {
  authApi,
  googleApi,
  scheduleSettingApi,
  userApi,
  recruitmentTypeApi,
  departmentApi,
  positionApi,
  generalConfigApi,
  timeKeepingApi,
  bookingApi,
  locationApi,
  regulationConfigApi,
  reportApi,
  approvalConfigApi,
  confirmationApi,
  leaveRegulationConfigApi,
  overtimeSatisticApi,
  reminderTimeApi,
  contactApi,
  schedulesApi,
};
